function getOverlap1D(aMin: number, aMax: number, bMin: number, bMax: number) {
    const overlap1 = aMax - bMin;
    const overlap2 = bMax - aMin;

    return Math.max(0, Math.min(overlap1, overlap2, aMax - aMin, bMax - bMin));
}
function getOverlap2D(
    aX: number,
    aW: number,
    aY: number,
    aH: number,
    bX: number,
    bW: number,
    bY: number,
    bH: number
) {
    const overlapX = getOverlap1D(aX, aX + aW, bX, bX + bW);
    const overlapY = getOverlap1D(aY, aY + aH, bY, bY + bH);
    return overlapX * overlapY;
}
function getDOMRectOverlap(
    a: Pick<DOMRect, "x" | "width" | "y" | "height">,
    b: Pick<DOMRect, "x" | "width" | "y" | "height">
) {
    return getOverlap2D(
        a.x,
        a.width,
        a.y,
        a.height,
        b.x,
        b.width,
        b.y,
        b.height
    );
}
export function elementVisible(element: HTMLElement) {
    if (element.nodeType === 8) return 0;
    const mass = element.offsetWidth * element.offsetHeight;
    let visibleMass = mass;
    const elementRect = element.getBoundingClientRect();

    let parent: HTMLElement | null = element;
    while ((parent = parent.parentElement) != null) {
        const parentRect = parent.getBoundingClientRect();
        //elementRect.x += parent.scrollLeft;
        //console.log(elementRect, parentRect);
        const visible = getDOMRectOverlap(elementRect, parentRect);
        if (visible < visibleMass) visibleMass = visible;
    }

    return visibleMass / mass;
}
